export default __webpack_public_path__ + "static/slider-1-8ad9150f6c53db00f134600137b0bf1f.webp";